import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  sectionWrapper: {},
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    maxWidth: { md: 'calc( 100% - 354px)' },
  },
  wrapper: {
    padding: {
      sm: '32px 40px 40px 40px',
      xs: '30px 20px',
    },
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    overflow: 'hidden',
    gap: {
      xs: '100px',
      sm: '24px',
    },
    width: '100%',
  },
  infoWrapper: {
    display: 'flex',
    gap: {
      xs: '30px',
      sm: '24px',
    },
    maxWidth: '600px',
    flexDirection: {
      xs: 'column',
      sm: 'row',
    },
    width: '100%',
    overflow: 'visible',
  },
  button: {
    marginTop: '8px',
    padding: '0px 30px',
    paddingBlock: {
      xs: '12px',
    },
    fontWeight: '400',
    '&.Mui-disabled': {
      backgroundColor: 'blue.400',
      color: 'neutral.white',
    },
  },
  animationTypography: {
    transform: 'translateY(0px)',
    opacity: 1,
    transition: 'transform 0.8s ease-out, opacity 0.8s ease-out',
  },
  animationTypographyAfter: {
    transform: 'translateY(100px)',
    opacity: '0',
  },
  arrowIcon: {
    color: 'neutral.black',
  },
  textField: {
    '& .MuiInput-root': {
      background: 'transparent',
    },
    '& .MuiInput-root:hover': {
      background: 'transparent',
    },
    '& .MuiInput-root:before': {
      borderBottomColor: 'border.light',
    },
    '& .MuiInput-root:after, .MuiInput-root:hover:after': {
      borderBottomColor: 'neutral.white',
    },
    '& .MuiInputBase-input::placeholder': {
      opacity: 1,
    },
    '& .MuiInputBase-input': {
      color: 'text.primaryDark',
    },
  },
  darkTextField: {
    width: '100%',
    [`& .MuiInputBase-root input::placeholder`]: {
      color: '#ffffff !important',
      opacity: '1',
    },
    [`& .MuiInputBase-root:hover input::placeholder`]: {
      color: '#ffffff !important',
      opacity: '1',
    },
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent !important',
      '&.Mui-focused': {
        backgroundColor: 'custom.lightGrey !important',
      },
      '&:hover': {
        backgroundColor: 'custom.lightGrey !important',
      },
      '&::before': {
        borderBottom: '1px solid',
        borderColor: 'border.light',
      },
      '&:hover::before': {
        borderBottom: '1px solid',
        borderColor: '#ffffff1A !important',
      },
      '&.Mui-focused::before': {
        borderBottom: '1px solid',
        borderColor: 'border.light',
      },
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#ffffff !important',
        borderTop: 'none !important',
        borderLeft: 'none !important',
        borderRight: 'none !important',
        borderRadius: '0px !important',
      },
      '&:hover fieldset': {
        borderColor: '#ffffff !important',
        borderTop: 'none !important',
        borderLeft: 'none !important',
        borderRight: 'none !important',
        borderRadius: '0px !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ffffff !important',
        borderTop: 'none !important',
        borderLeft: 'none !important',
        borderRight: 'none !important',
        borderRadius: '0px !important',
      },
    },
    '& .MuiInputBase-input': {
      color: '#ffffff !important',
      '&::placeholder': {
        color: '#ffffff !important',
      },
    },
    '& input:-webkit-autofill, & input:-webkit-autofill:focus, & input:-webkit-autofill:hover, & textarea:-webkit-autofill, & textarea:-webkit-autofill:focus, & textarea:-webkit-autofill:hover':
      {
        WebkitBoxShadow: '0 0 0 1000px transparent inset',
        WebkitTextFillColor: '#fff',
        caretColor: '#fff',
        backgroundColor: 'transparent',
        transition: 'background-color 5000s ease-in-out 0s',
      },
  },
  imageWrapper: {
    width: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#00000066',
  },
  image: {
    width: '28px',
    height: '24px',
  },
  bgImage: {
    width: '354px',
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: -1,
    ' img': {
      top: 0,
      width: '100%',
      objectFit: 'initial',
      height: 'auto !important',
      zIndex: -1,
    },
  },
  companyLogo: {
    ' img': {
      marginTop: '22px',
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      scale: 1.3,
    },
  },
  title: {},
  textFieldCaptchaWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxWidth: '100%',
    overflow: 'visible',
  },
  captchaWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    overflow: 'visible',
    marginRight: '16px',
    paddingBottom: '-16px',
    '& > div': {
      maxWidth: '100%',
      transform: 'scale(0.85)',
      transformOrigin: 'left top',
      marginRight: '16px',
    },
    '& iframe': {
      maxWidth: '100%',
    },
    '@media (max-width: 350px)': {
      '& > div': {
        transform: 'scale(0.75)',
      },
    },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
